// extracted by mini-css-extract-plugin
export default {"tile":"MergeSelectClientsStep_tile__1IJvU","tilePrimary":"MergeSelectClientsStep_tilePrimary__7Av2e"};